import { render } from "./DeleteTaskItemDialog.vue?vue&type=template&id=9ed7b99e"
import script from "./DeleteTaskItemDialog.vue?vue&type=script&lang=js"
export * from "./DeleteTaskItemDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__